<template>
  <div class="apply">
    <img :src="require('../../assets/img/logo.png')" alt="">
    <p class="title">{{ surveyInfo.title }}</p>
    <p class="info">&nbsp;&nbsp;&nbsp; {{ surveyInfo.intro }}</p>
    <template v-if="isSuccess">
      <div class="success">
        <i class="el-icon-circle-check" style=""></i><br>
        提交成功 !
      </div>
    </template>
    <template v-else>
      <div class="content">
        <p style="margin-right: 0;width: 100%;position: relative;margin-top: 10px">
          <span><i class="red-star">*</i>&nbsp;&nbsp;公司名称：</span><br>
          <el-input v-model="surveyParams.companyName" />
        </p>
        <p style="margin-right: 0;width: 100%;position: relative;margin-top: 10px">
          <span><i class="red-star">*</i>&nbsp;&nbsp;联系人：</span><br>
          <el-input v-model="surveyParams.contactName" />
        </p>
        <p style="margin-right: 0;width: 100%;position: relative;margin-top: 10px">
          <span><i class="red-star">*</i>&nbsp;&nbsp;联系电话：</span><br>
          <el-input v-model="surveyParams.contactPhone" />
        </p>
        <div v-for="(item, index) in surveyParams.result" :key="index" class="question-content">
          <p class="question-title">{{ index + 1 }}、{{ item.questionName }}</p>
          <template v-if="item.type === 'select'">
            <div style="width: 100%">
              <div v-for="(option,optionIndex) in item.options" :key="optionIndex" style="margin-top: 10px">
                <el-radio v-model="item.answer" :label="optionIndex">{{ option.content }}</el-radio>
              </div>
              <div v-if="item.options[item.answer] && item.options[item.answer].optionAdvise" style="margin-top: 10px">
                <el-input v-model="item.options[item.answer].optionAdviseAnswer" :placeholder="item.options[item.answer].optionAdvise" type="textarea" rows="3" style="width: 100%"></el-input>
              </div>
            </div>
          </template>
          <template v-else-if="item.type === 'mulSelect'">
            <div style="width: 100%">
              <el-checkbox-group v-model="item.answer" style="margin-top: 10px">
                <div v-for="(option,optionIndex) in item.options" :key="optionIndex"  style="margin-top: 10px">
                  <el-checkbox :label="optionIndex">{{ option.content }}</el-checkbox>
                </div>
              </el-checkbox-group>
              <template v-if="item.answer && item.answer.length > 0">
                <template v-for="(advise,adviseIndex) in item.answer">
                  <div v-if="item.options[advise].optionAdvise" :key="adviseIndex" style="margin-top: 10px">
                    <el-input v-model="item.options[advise].optionAdviseAnswer" :placeholder="item.options[advise].optionAdvise" type="textarea" rows="3" style="width: 100%"></el-input>
                  </div>
                </template>
              </template>
            </div>
          </template>
          <template v-else>
            <div style="width: 100%;margin-top: 10px">
              <el-input v-model="item.answer" type="textarea" rows="3" style="width: 100%"></el-input>
            </div>
          </template>
          <div v-if="item.advise" style="margin-top: 10px">
            <span>{{ item.advise }}：</span><br>
            <el-input v-model="item.adviseAnswer" type="textarea" rows="3" style="width: 100%"></el-input>
          </div>
        </div>
      </div>
      <div class="submit-button" @click="handleSubmit">提交问卷</div>
    </template>

  </div>

</template>

<script>
export default {
  name: 'Survey',
  data() {
    return {
      isSuccess: false,
      surveyParams: {
        questionPkid: '',
        companyName: '',
        contactName: '',
        contactPhone: '',
        result: ''
      },
      surveyInfo: {
        title: '',
        intro: ''
      }
    }
  },
  created() {
    this.surveyParams.questionPkid = this.$route.query.pkid
    this.getInfo()
  },
  methods: {
    handleSubmit() {
      if (!this.surveyParams.companyName) {
        return this.$message.warning('请填写公司名称 !')
      }
      if (!this.surveyParams.contactName) {
        return this.$message.warning('请填写联系人 !')
      }
      if (!this.surveyParams.companyName) {
        return this.$message.warning('请填写联系电话 !')
      }
      if (this.surveyParams.result) {
        for (let i = 0; i < this.surveyParams.result.length; i++) {
          const resultItem = this.surveyParams.result[i]
          if ((resultItem.answer === '' || (resultItem.type === 'mulSelect' && resultItem.answer.length === 0)) || (resultItem.advise && resultItem.adviseAnswer === '')) {
            return this.$message.warning('问卷中有必填项未填写 !')
          }
          for (let j = 0; j < resultItem.options.length; j++) {
            if (resultItem.type === 'select') {
              if (resultItem.answer === j && resultItem.options[j].optionAdvise && resultItem.options[j].optionAdviseAnswer === '') {
                return this.$message.warning('问卷中有必填项未填写 !')
              }
            } else if (resultItem.type === 'mulSelect') {
              if (resultItem.options[j].optionAdvise && (resultItem.answer && resultItem.answer.includes(j)) && resultItem.options[j].optionAdviseAnswer === '') {
                return this.$message.warning('问卷中有必填项未填写 !')
              }
            }
          }
        }
      }
      const params = {
        questionPkid: this.surveyParams.questionPkid,
        companyName: this.surveyParams.companyName,
        contactName: this.surveyParams.contactName,
        contactPhone: this.surveyParams.contactPhone,
        result: JSON.stringify(this.surveyParams.result)
      }
      this.$post('/front/index/submitSurvey', params).then(res => {
        if (res) {
          this.isSuccess = true
        }
      })
    },
    getInfo() {
      this.$get('/front/index/questionSurvey', this.$route.query.pkid).then(res => {
        if (res) {
          const result = JSON.parse(res.content)
          result.forEach(item => {
            if (item.advise) {
              item.adviseAnswer = ''
            }
            if (item.type === 'other') {
              item.answer = ''
            } else {
              item.type === 'select' ? item.answer = '' : item.answer = []
              if (item.options && item.options.length > 0) {
                item.options.forEach(op => {
                  if (op.optionAdvise) {
                    op.optionAdviseAnswer = ''
                  }
                })
              }
            }
          })
          this.surveyParams.result = result
          this.surveyInfo.title = res.title
          this.surveyInfo.intro = res.intro
        }
      })
    }
  },
  watch: {
    surveyParams: {
      handler(val) {
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.apply {
  padding: 3%;
  .success {
    width: 100%;
    margin-top: 50px;
    font-size: 50px;
    text-align: center;
    font-weight: 600;
    color: #409EFF
  }
  img {
    width: 50%;
  }
  .title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .info {
    margin-top: 5px;
    span {
      font-size: 16px;
      font-weight: 600;
    }
  }
  .content {
    margin: 10px auto 0 auto;
    .red-star {
      font-size: 15px;
      font-weight: 600;
      color: red;
    }
    .question-content {
      width: 100%;
      margin-top: 10px;
      .question-title {
        box-sizing: border-box;
        padding: 10px;
        width: 100%;
        font-size: 16px;
        font-weight: 600;
        background-color: #F8F8F8;
      }
    }
  }
  .submit-button {
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin: 30px auto 0 auto;
    background: #EA5504;
    border-radius: 2px;
    text-align: center;
    font-size: 18px;
    color: #FFFFFF;
    cursor: pointer;
  }
  .submit-button:hover {
    opacity: 0.8;
  }
}

</style>
